import React, { useEffect } from 'react';
import { fileEventQueue, FileEventType } from '@/utils/fileEvent';

interface PDFViewerProps {
    filePath: string;
}

// Percent-encode each segment but keep the separators, so a name with spaces or
// a '#' survives while the path still reaches the backend as a path.
const encodePath = (path: string) => path.split('/').map(encodeURIComponent).join('/');

const PDFViewer: React.FC<PDFViewerProps> = ({ filePath }) => {
    const [version, setVersion] = React.useState<number>(0);

    useEffect(() => {

        if (filePath) {
            fileEventQueue.setEventCallback(`${filePath}_pdfviewer`, async (events) => {
                const event = events.find(e => e.path === filePath && e.type === FileEventType.WRITE);
                if (event) {
                    setVersion(v => v + 1)
                    // openNotification()
                }
            })
        }
    }, [filePath]);

    const token = localStorage.getItem('token');

    // Hand the viewer the real file URL, not a blob: URL. The browser's built-in
    // PDF viewer names its download after the last segment of the URL it was
    // given, and a blob: URL offers it nothing but a UUID. GET /resource/raw
    // accepts the JWT as a query param precisely because an embedded viewer
    // cannot attach an Authorization header; `v` re-fetches after a write.
    const uri = token
        ? `${import.meta.env.VITE_API_URL}/resource/raw${encodePath(filePath)}?token=${encodeURIComponent(token)}&v=${version}`
        : undefined;

    return (
        <div className='w-full h-full'>
            {uri && (
                <iframe
                    src={uri}
                    className='w-full h-full border-0'
                    title='PDF Viewer'
                />
            )}
        </div>
    );
};

export default PDFViewer;
